(function () {
    Raven.addPlugin(Raven.Plugins.Angular);
})();
